import { render } from "./ExpertArticles.vue?vue&type=template&id=12509ec6&scoped=true"
import script from "./ExpertArticles.vue?vue&type=script&lang=js"
export * from "./ExpertArticles.vue?vue&type=script&lang=js"

import "./ExpertArticles.vue?vue&type=style&index=0&id=12509ec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12509ec6"]])

export default __exports__